import AirPlayIcon from 'components/icons/airplay'
import { AllowedKeys } from 'components/KeyboardEventHandler'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { Wrapper } from './styled'

interface Props {
  onClick?: () => void
}

const AirPlay = ({ onClick }: Props) => {
  const { t } = useTranslation()

  return (
    <Wrapper
      onKeyDown={e => {
        ;[AllowedKeys.SPACE, AllowedKeys.SPACE_CHAR].some(key => [e.nativeEvent.code, e.nativeEvent.key].includes(key)) &&
          e.nativeEvent.stopImmediatePropagation()
      }}
      data-testid="vp-airplay-btn"
      data-tip={t('AirPlay')}
      className="vp-airplay-btn"
      onClick={onClick}
    >
      <AirPlayIcon />
    </Wrapper>
  )
}

export default AirPlay
